import { Injectable, Output, EventEmitter, Directive } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ServerConn } from '../_services/serverConn.service';

@Injectable({
    providedIn: 'root'
})
export class ProductsService {

  data: any[] = [];
  commData: any[] = [];
  pending: any[] = [];
  length = 0;
  lact: any[] = [];
  @Output()
  needUpdate: EventEmitter<any> = new EventEmitter();
  selectedCEA = '';

  constructor(private server: ServerConn) { }

  get(force = false, search = '', tblstart = 0, tbllimit = 0, tblorder = ''): Observable<any> {
    if (!this.data.length || force) {
      return this.server.get(
        'products',
        {
          search: search,
          tblstart: tblstart,
          tbllimit: tbllimit,
          tblorder: tblorder,
        }
      )
      .pipe(
        tap(
          (res: any) => {
            const data = (typeof res.json !== 'undefined') ? res.json() : res;
            this.data = data.data;
          }
        )
      );
    } else {
      return of({
        result: true,
        data: this.data
      });
    }
  }

  getForComm(force = false, comm): Observable<any> {
    if (!this.commData.length || force) {
      return this.server.get(
        'products/comm',
        {
          c: comm
        }
      )
      .pipe(
        tap(
          (res: any) => {
            const data = (typeof res.json !== 'undefined') ? res.json() : res;
            this.commData = data.data;
          }
        )
      );
    } else {
      return of({
        result: true,
        data: this.commData
      });
    }
  }

  getPrice(product, idcomunidad) {
    // Validar que el producto no sea null o undefined
    if (!product || !product.id) {
      console.warn('getPrice llamado con producto inválido:', product);
      return of({ result: false, data: null, errors: ['Producto inválido'] });
    }
    
    return this.server.post(
      'products/price',
      {
        r: product.id,
        q: 1,
        rp: product.reposicion,
        c: idcomunidad
      }
    );
  }

  getById(id): Observable<any> {
    /**
     * Retornamos un producto por su ID
     */
    return this.server.get(
      'products/' + id
    )
    .pipe(
      tap(
        res => {
          if (res.result) {
            this.data = res.data;
          }
        }
      )
    );
  }

  save(form, idproduct: number) {
    if (form.comunidad == -1) {
      return this.server.post(
        'products/sage/save/default?r=' + idproduct+'&c='+form.codigo
      );  
    } else {
      return this.server.post(
        'products/sage/save?r=' + idproduct+'&comm='+form.comunidad+'&c='+form.codigo
      );
    }
  }

  delete(idproduct: number | number[]) {
    return this.server.post(
      'products/delete',
      {
        r: JSON.stringify(idproduct)
      }
    );
  }

  deleteSage(codigo :string) {
    return this.server.post(
      'products/sage/delete?r=' + codigo
    );
  }

  getPrices(product, idcomunidad) {
    return this.server.post(
      'products/price',
      {
        r: product.id,
        q: 1,
        rp: product.reposicion,
        c: idcomunidad
      }
    );
  }

  getSage(idproduct: number): Observable<any> {
    return this.server.get(
      'products/sage',
      {
        r: idproduct
      }
    );
  }

  getCommunities(): Observable<any> {
    return this.server.get('comunidades/get');
  }

}
